<template>
  <div class="load-bar">
    <div class="bar"></div>
    <div class="bar"></div>
    <div class="bar"></div>
  </div>
</template>

<style>
.load-bar {
  position: fixed;
  top: 0;
  width: 100%;
  height: 2px;
  background-color: #e7e7e7;
   z-index: 999999;
}
.bar {
  content: "";
  display: inline;
  position: absolute;
  width: 10%;
  height: 100%;
  left: 50%;
  z-index: 999999;
  text-align: center;
}
.bar:nth-child(1) {
  background-color: #3845ff;
  animation: loading 0.75s linear infinite;
}
@keyframes loading {
  from {
    left: 0;
    width: 0;
    z-index: 100;
  }
  33.3333% {
    left: 0;
    width: 60%;
    z-index: 10;
  }
  to {
    left: 100%;
    width: 100%;
  }
}
</style>